import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { WeightInput } from 'ui-components/components/weight-input';
import { WeightUnit } from '../../../../../enums/weight-unit';
import {
  convertFromWeightUnitEnum,
  convertToWeightUnitEnum,
} from '../../../../../services/unit-services/weights/weight-unit-enum-converter';
import { toFixedNumber } from '../../../../../services/number-formatting-service';

import style from './style.module.less';

export const ManualWeightContainer = ({ disabled = false, onChange, weight, unit }) => {
  const className = WeightUnit[unit] === WeightUnit.Grams ? style.weight_gr : style.weight_oz;

  const onWeightChange = useCallback(
    (formWeight, weightInputUnit) => {
      const newWeight = {
        unit: convertToWeightUnitEnum(weightInputUnit),
        value: formWeight,
      };
      onChange(newWeight);
    },
    [onChange],
  );
  return (
    <WeightInput
      className={className}
      disabled={disabled}
      onChange={onWeightChange}
      unit={convertFromWeightUnitEnum(unit)}
      weight={toFixedNumber(weight)}
    />
  );
};

ManualWeightContainer.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  weight: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
};
